import { useEffect, useState } from 'react'
import validatePassword from './validatePassword'

export default function usePasswordChecker(password, confirmPassword) {
  const [error, setError] = useState('')
  const [validPassword, setValidPassword] = useState(false)
  const isEmpty = password === '' && confirmPassword === ''
  const isMismatched = password !== confirmPassword
  const isInvalid = !validatePassword(password)

  useEffect(() => {
    if (isEmpty) {
      setValidPassword('')
      setError('')
      return
    }
    if (isMismatched) {
      setValidPassword('')
      setError('Passwords do not match')
      return
    }
    if (isInvalid) {
      setValidPassword('')
      setError(
        'Password should be between 8 and 32 characters and contains at least one lowercase letter, one uppercase letter and one number'
      )
      return
    }
    setError('')
    setValidPassword(password)

    // eslint-disable-next-line
  }, [password, confirmPassword])

  return { validPassword, isEmpty, isMismatched, isInvalid, error }
}
